import type {
  GetOrganizationSiteV2Request,
  OrganizationSiteV2,
  ResponseError,
} from '@rtkwlf/rendall';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useOrganizationContext } from '@packages/legacy/organization-context';

import { useRendallApi } from '../use-rendall-api';

export const getOrganizationSiteV2QueryKey = (
  organizationId: string,
  siteUUID: string,
) => [organizationId, 'rendall', 'get-organization-site-v2', siteUUID];

export const useOrganizationSiteV2 = (
  siteUUID: string,
  options?: Omit<
    UseQueryOptions<OrganizationSiteV2, ResponseError>,
    'queryFn' | 'queryKey'
  >,
) => {
  const api = useRendallApi();
  const { selectedOrganization } = useOrganizationContext();
  const request: GetOrganizationSiteV2Request = {
    organizationId: selectedOrganization.id,
    siteUUID,
  };
  return useQuery({
    queryFn: () => api.getOrganizationSiteV2(request),
    queryKey: getOrganizationSiteV2QueryKey(selectedOrganization.id, siteUUID),
    staleTime: 60 * 1000,
    ...options,
  });
};
